export const authToken = 'KEY_AUTH';
